import { render, staticRenderFns } from "./documentAgentAiGenerateDialog.vue?vue&type=template&id=5e97b190&scoped=true&lang=pug"
import script from "./documentAgentAiGenerateDialog.vue?vue&type=script&lang=js"
export * from "./documentAgentAiGenerateDialog.vue?vue&type=script&lang=js"
import style0 from "./documentAgentAiGenerateDialog.vue?vue&type=style&index=0&id=5e97b190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e97b190",
  null
  
)

export default component.exports